import { FC } from 'react';
import styled from 'styled-components';

const ButtonTextElement = styled.span<IProps>`
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  color: ${props => (props.color ? props.color : props.theme.vars.newColor.darkGS1)};
`;

export interface IProps {
  /** Text color. Defaults to theme.vars.newColor.darkGS1 */
  color?: string;
}
export const ButtonText: FC<IProps> = props => {
  const { color } = props;
  return <ButtonTextElement color={color}>{props.children}</ButtonTextElement>;
};
